import keyMirror from 'keymirror';

const types = keyMirror({
	RESET_CONSTRUCTION_LIST: null,
	ADD_CONSTRUCTION: null,
	DELETE_CONSTRUCTION: null,
	UPDATE_CONSTRUCTION: null,
});

export default types;



// WEBPACK FOOTER //
// ./src/constants/ConstructionConstants.js